import { useEffect, useRef } from 'react';

/** Opens a native <dialog> as modal on mount (focus trap + Esc for free) and routes Esc to onClose. */
export function useModalDialog(onClose: () => void) {
  const ref = useRef<HTMLDialogElement | null>(null);
  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
    const onCancel = (e: Event) => { e.preventDefault(); onClose(); };
    d?.addEventListener('cancel', onCancel);
    return () => d?.removeEventListener('cancel', onCancel);
  }, [onClose]);
  return ref;
}
